import { AxiosResponse } from 'axios';
import { SET_PHOTO_UNDERLINES, SET_PHOTO_UNDERLINE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PHOTO_UNDERLINE_ISLOADING,
  DELETE_PHOTO_UNDERLINE,
  EDIT_PHOTO_UNDERLINE,
  GET_PHOTO_UNDERLINE,
  GET_PHOTO_UNDERLINES,
  REGISTER_PHOTO_UNDERLINE,
  TOGGLE_PHOTO_UNDERLINE_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import PhotoUnderline from '@/services/photo_underline';
import { Module } from 'vuex';
import { EditPhotoUnderline, RegisterPhotoUnderline, GetPhotoUnderline } from '@/dtos/photo_underline.dto';

const photoUnderline: Module<any, {}> = {
  state: {
    photoUnderline: {
      data: null,
      isLoading: false,
    },
    photoUnderlines: {
      data: null,
      metaData: null,
      isLoading: false,
    },
  },
  getters: {
    photoUnderline: (state: { photoUnderline: any }) => state.photoUnderline,
    photoUnderlines: (state: { photoUnderlines: any }) => state.photoUnderlines,
  },
  mutations: {
    [SET_PHOTO_UNDERLINE]: (
      state: { photoUnderline: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.photoUnderline.data = payload.data) : null,
        (state.photoUnderline.isLoading = payload.isLoading);
    },
    [SET_PHOTO_UNDERLINES]: (
      state: { photoUnderlines: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.photoUnderlines.data = payload.data) : null,
      payload.metaData != null
          ? (state.photoUnderlines.metaData = payload.metaData)
          : null,
        (state.photoUnderlines.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PHOTO_UNDERLINE]: async ({ commit }: any, payload: RegisterPhotoUnderline) => {
      commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: true });

      const result: AxiosResponse = await PhotoUnderline.registerPhotoUnderline(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PHOTO_UNDERLINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PHOTO_UNDERLINE, { isLoading: false });
        return false;
      }
    },
    [GET_PHOTO_UNDERLINES]: async ({ commit }: any, payload: any) => {
      commit(SET_PHOTO_UNDERLINES, { data: null, isLoading: true });

      const result: AxiosResponse = await PhotoUnderline.getPhotoUnderlines(
        payload as GetPhotoUnderline
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PHOTO_UNDERLINES, { data: result.data.data, metaData: result.data.metaData, isLoading: false });
          return true;
        }
        commit(SET_PHOTO_UNDERLINES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PHOTO_UNDERLINES, { isLoading: false });
        return false;
      }
    },
    [GET_PHOTO_UNDERLINE]: async ({ commit }: any, payload: any) => {
      commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: true });

      const result: AxiosResponse = await PhotoUnderline.getPhotoUnderlines(
        payload as GetPhotoUnderline
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PHOTO_UNDERLINE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PHOTO_UNDERLINE, { isLoading: false });
        return false;
      }
    },
    [EDIT_PHOTO_UNDERLINE]: async ({ commit }: any, payload: EditPhotoUnderline) => {
      commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: true });

      const result: AxiosResponse = await PhotoUnderline.editPhotoUnderline(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PHOTO_UNDERLINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PHOTO_UNDERLINE, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_PHOTO_UNDERLINE_IS_ACTIVE]: async ({ commit, state }: any, payload: EditPhotoUnderline) => {
      commit(SET_PHOTO_UNDERLINE, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await PhotoUnderline.togglePhotoUnderlineIsActive(
        payload
      );

      if (result) {
        if (result.data.status) {
          let index;
          if (state.photoUnderlines.data) {
            state.photoUnderlines.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null)
              state.photoUnderlines.data[index].isActive = result.data.data.isActive;
          }
          commit(SET_PHOTO_UNDERLINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PHOTO_UNDERLINE, { isLoading: false });
        return false;
      }
    },
    [DELETE_PHOTO_UNDERLINE]: async ({ commit }: any, payload: string) => {
      commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: true });

      const result: AxiosResponse = await PhotoUnderline.deletePhotoUnderline(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PHOTO_UNDERLINE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PHOTO_UNDERLINE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PHOTO_UNDERLINE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PHOTO_UNDERLINE_ISLOADING]: ({ commit }) => {
      commit(SET_PHOTO_UNDERLINE, { isLoading: false });
      commit(SET_PHOTO_UNDERLINES, { isLoading: false });
    },
  },
};

export default photoUnderline;

